// extracted by mini-css-extract-plugin
module.exports = {"container":"redirect_container__VLKum","ring":"redirect_ring__VH6gQ","ringA":"redirect_ringA__tZ5Te"};